import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://your-demo-project.supabase.co";
const SUPABASE_KEY = "your-demo-anon-key";

// Provide a custom `fetch` implementation as an option
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  global: {
    fetch: (...args) => fetch(...args),
  },
});
